import React from 'react';

function CommandValue() {
  return <div>00</div>;
}

export default CommandValue;



// WEBPACK FOOTER //
// ./src/components/CommandValue.jsx